<template>
    <div>
        <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>Equipment Mgmt</el-breadcrumb-item>
        <el-breadcrumb-item>Equipment</el-breadcrumb-item>
      </el-breadcrumb>
        <!-- 卡片视图区域 -->
        <el-card>
        <!-- 搜索与添加区域 -->
         <collapse v-hasPermission="['equipment:select']"  @getDataList="search">
        <collapse-item>
          <span>Device ID:</span>
          <el-input placeholder="Please input the Device ID" v-model.trim="queryInfoparams.params.uniqueCode" clearable></el-input>
        </collapse-item>
        <collapse-item  v-if="this.state !== '3'">
          <span>Plumber Company:</span>
          <el-select v-model="queryInfoparams.params.companyId" filterable placeholder="please input the con" clearable @change="selectHandler">
            <el-option  v-for="item in companyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id">
            </el-option>
          </el-select>
        </collapse-item>
        <collapse-item v-if="this.state === '1'" >
          <span>Agent:</span>
              <el-select v-model="queryInfoparams.params.agencyId" filterable placeholder="please input the agant" clearable @change="selectHandler" >
               <el-option  v-for="item in agencyList"
                  :key="item.id"
                  :label="item.agencyName"
                  :value="item.id">
              </el-option>
           </el-select>
        </collapse-item>
        <collapse-item>
          <span class="demonstration">Up Time:</span>
          <el-date-picker v-model="startTime0" type="daterange" range-separator="to" start-placeholder="start Date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"   end-placeholder="end Date" @change="selectHandler"></el-date-picker> 
        </collapse-item>
        <collapse-item>
          <span class="demonstration">Down Time:</span>
          <el-date-picker v-model="stopTime1" type="daterange" range-separator="to" start-placeholder="start Date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"   end-placeholder="end Date" @change="selectHandler" ></el-date-picker> 
        </collapse-item>
        <collapse-item>
          <span class="demonstration">Calibration Time:</span>
           <el-date-picker v-model="calibrationTime1" type="daterange" range-separator="to" start-placeholder="start Date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"   end-placeholder="end Date" @change="selectHandler" ></el-date-picker> 
        </collapse-item>
        <collapse-item>
          <span>Equipment Status:</span>
            <el-select v-model="queryInfoparams.params.status"  placeholder="Device S tatus" @change="selectHandler">
              <el-option label="Enable" value='1'></el-option>
              <el-option label="Disable" value='2'></el-option>
              <el-option label="Terminated" value='3'>  </el-option>
            </el-select>
        </collapse-item>
        <collapse-item>
        </collapse-item>
      </collapse>
        <el-row type="flex" justify="end">
            <el-col class="searchBtns" :span="6">
            <el-button-group>
                <el-button plain 
                  size="small" 
                  v-hasPermission="['equipment:']"
                  >Device Terminated</el-button>
                <el-button plain
                  size="small" 
                  icon="el-icon-download"
                  v-hasPermission="['equipment:export']"
                  @click="exportExcel">Export
                </el-button>
            </el-button-group>
            </el-col>
        </el-row>
         <!-- 设备列表区域 -->
        <el-table type="selection" :data="equipmentList"  border stripe>
          <el-table-column type="index" label="No."></el-table-column>
          <el-table-column  label="Device ID" sortable prop="uniqueCode" width="190"></el-table-column>
          <el-table-column label="agent" sortable prop="agencyName" width="110"></el-table-column>
          <el-table-column label="Plumber company" sortable prop="companyName" width="170"></el-table-column>
          <el-table-column label="Plumber name" sortable prop="attribute2" width="140"></el-table-column>
          <el-table-column label="Up time" sortable prop="startTime" width="110"></el-table-column>
          <el-table-column label="Down time" sortable prop="stopTime" width="120"></el-table-column>
          <el-table-column label="Reason" sortable prop="stopDesc" width="90"></el-table-column>
          <el-table-column label="Add up using time" sortable prop="duration" width="170"></el-table-column>
          <el-table-column label="Last calibration time" sortable prop="calibrationTime" width="190"></el-table-column>
          <el-table-column label="Recommended calibration time" sortable prop="proposalTime" width="240"></el-table-column>
           <el-table-column label="status" sortable prop="status" width="90">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==='1'" type="success">Enable</el-tag>
              <el-tag v-else-if="scope.row.status ==='2'" type="info">disabled</el-tag>
              <el-tag v-else-if="scope.row.status ==='3'" type="info">Terminated</el-tag>
            </template>
          </el-table-column>
          <el-table-column v-if="this.state !== '3'" label="Operate" width="320px" fixed="right">
            <template slot-scope="scope">
              <!-- 修改按钮 -->
              <el-link icon ="el-icon-edit"
                v-if="scope.row.status !== '3' "
              @click="equipmentTerminate(scope.row.id)" 
              v-hasPermission="['equipment:terminateEquipment']"
                >Terminated</el-link>
                 <el-divider direction="vertical"></el-divider>
              <el-link icon ="el-icon-edit" 
                @click="showEditDialog(scope.row.id)" 
                v-hasPermission="['equipment:calibrateEquipment']"
                >Calibration</el-link>
              <el-divider direction="vertical"></el-divider>
                <el-link
                  type="text success"
                  size="small"
                  icon="el-icon-unlock"
                  v-if="scope.row.status === '2' "
                  v-hasPermission="['equipment:startEquipment']"
                  @click="equipmentEnable(scope.row.id)"
                  >Enable</el-link
                >
                <el-link
                  type="text "
                  size="small"
                  icon="el-icon-lock"
                  v-if="scope.row.status === '1'"
                  v-hasPermission="['equipment:stopEquipment']"
                  @click="showEditDialogOfDis(scope.row.id)"
                  >Disable</el-link>
            </template>
          </el-table-column>
        </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"

        @current-change="handleCurrentChange"

        :current-page="queryInfoparams.current"

        :page-sizes="[10, 50, 100, 200]"

        :page-size="queryInfoparams.size"

        layout="total, sizes, prev, pager, next, jumper"

        :total="total"

      ></el-pagination>
     </el-card> 
		<!-- 设备校准户的对话框   合并为一个对话框-->
    <el-dialog title="Please Enter" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="70px">
        <el-form-item label="Calibration Time:"  label-width="150px">
           <el-date-picker v-model="addForm.calibrationTime" type="date"  start-placeholder="start Date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="editEquipmentInfo">Submit</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Please input" :visible.sync="editDialogVisibleDis" width="50%" @close="editDialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="70px">
        <el-form-item label="Reason" label-width="90px" prop="context">
          <el-input v-model="addForm.stopDesc" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisibleDis = false">Cancel</el-button>
        <el-button type="primary" @click="equipmentDisable">Submit</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import db from '@/services/localstorage'
  import Collapse from '@/components/collapse/Collapse'
  import CollapseItem from '@/components/collapse/CollapseItem'
  export default {
    components:{
      Collapse,
      CollapseItem
    },
    data(){
      return{
        stopTime1:'',
        calibrationTime1:'',
        startTime0:'',
        queryInfoparams: {
        // 当前页码
        current: 0,// @ts-nocheck
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      user: {},
      state: '',
      // 设备列表
      equipmentList: [],
      agencyList: [],
      companyList: [],
      total: 0,
      // 控制添加 设备对话框的显示与隐藏
      addDialogVisible: false,
      // 设备校准表单数据
      addForm: {
        calibrationTime:'',
        stopDesc:'',
        proposalTime:''
      },
      unitData: {
        itemCode: '',
        itemName: ''
      },
      addFormRules:{
        calibrationTime:[
           { required: true, message: 'Date cannot be empty', trigger: 'blur' },
        ]
      },
      editForm: {},
      editDialogVisible: false,
      editDialogVisibleDis:false,
    }
  },
  methods: {
    selectHandler(){
      if(this.startTime0 !== null)
      {
        this.queryInfoparams.params.startTime = this.startTime0[0]
        console.log( "startTime",this.queryInfoparams.params.startTime)
        this.queryInfoparams.params.endTime = this.startTime0[1]
      }
      else{
        this.queryInfoparams.params.startTime = ""
        this.queryInfoparams.params.endTime = ""
      }
      if(this.stopTime1 !== null)
      {
        this.queryInfoparams.params.startOfStopTime = this.stopTime1[0]
        this.queryInfoparams.params.endOfStopTime = this.stopTime1[1]
      }
      else{
        this.queryInfoparams.params.startOfStopTime = ""
        this.queryInfoparams.params.endOfStopTime =""
      }
      if(this.calibrationTime1 !== null){
        this.queryInfoparams.params.calibrationOfStartTime = this.calibrationTime1[0]
        this.queryInfoparams.params.calibrationOfEndTime = this.calibrationTime1[1]
      }
      else{
        this.queryInfoparams.params.calibrationOfStartTime = ""
        this.queryInfoparams.params.calibrationOfEndTime = ""
      }
    },
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getEquipmentList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getEquipmentList()
    },
    async equipmentEnable(id) {
        this.$confirm('Enable the device settings, are you sure?', 'Reminder', {
          confirmButtonText: 'confirm',
          cancelButtonText: 'cancel',
          type: 'warning'
        }).then(() => {
            this.$get(`equipment/equipmentEnable/${id}`).then(
                ({ data: res }) => {
                console.log("启用状态",res.msg)
                if(res.msg === "ARREARS"){
                  return this.$message.error('The device is in arrears ,You cannot be activated')
                }
                this.search()

                }
            )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel operation'
          })
      })
    },
    async equipmentTerminate(id){
        this.$confirm('Terminate the device, are you sure?', 'Reminder', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
            this.$get(`equipment/equipmentTerminate/${id}`).then(
                ({ data: res }) => {
                console.log("启用转台",res.msg)
                this.search()
                }
            )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel operation'
          })
      })
    },
    async equipmentDisable() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        this.$post('equipment/equipmentDisable', this.addForm).then(({ data: res }) => {
          console.log(res)
          if (res.msg == 'FREECYCLENOTNULL') {
            return this.$message.error('The free period of this device is not 0 and cannot be disabled')
          }
          if(res.msg == 'ERROR') {
            return this.$message.error('operation failed')
          }
          else if (res.msg == 'REPEATED') {
            return this.$message.error('Can’t activate and deactivate within one day')
          }
          this.$message.success('Successful operation')
          // 关闭对话框
          this.editDialogVisibleDis = false
          // 刷新数据列表
          this.search()
        })
      })
    },
    // 修改设备信息并提交
    editEquipmentInfo() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        this.$post('equipment/save', this.addForm).then(({ data: res }) => {
          console.log(res)
          if (res.msg !== 'SUCCESS') {
            return this.$message.error('operation failed')
          }
          this.$message.success('Successful operation')
          // 关闭对话框
          this.editDialogVisible = false
          // 刷新数据列表
          this.search()
        })
      })
    },
    // 监听修改设备对话框的关闭事件
    editDialogClosed() {
      this.addForm={}
      this.$refs.editFormRef.resetFields()
    },
    // 展示编辑设备的对话框
    async showEditDialog(id) {
      this.editDialogVisible = true
      this.$get(`equipment/selectEquipmentById/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm =res.data
      })
    },
    async showEditDialogOfDis(id) {
      this.editDialogVisibleDis = true
      this.$get(`equipment/selectEquipmentById/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm =res.data
      })
    },
    //导出excel
    async exportExcel(){
      console.log('-----------')
      let res = this.$export('equipment/exportExcel', JSON.stringify(this.queryInfoparams), 'Equipment')
    },
    search(){
        this.queryInfoparams.current=0
         this.getEquipmentList()
    },
    // 获取查询设备数据列表
    async getEquipmentList(data) {
      this.user  = db.get("user");
      this.state = this.user.userType
      this.$post('equipment/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.equipmentList = res.records
          this.total = res.total
          console.log(this.equipmentList)
        }
      )
    },
    //获取所有的代理商
    getAgencyList(){
      this.$post('agent/queryAgents', this.queryInfoparams).then(
        ({ data: res }) => {
          this.agencyList = res
          console.log("代理商",this.agencyList)
        }
      )
    },
    //获取所有水工公司
    getCompanyList() {
      this.$post('engineerCompany/queryEngineerCompanys', this.queryInfoparams).then(
        ({ data: res }) => {
          this.companyList = res
          console.log("水工公司",this.companyList)
        }
      )
    },
  },
  created() {
       this.search()
    if(this.user.userType=='1'){

      this.getAgencyList()

    }
    if(this.user.userType!='3'){

      this.getCompanyList()
    }
 
  },
}
</script>
<style lang="less" scoped>
.el-select {
  width: 100%;
}
.collapse.left.collapse-item span
{
color:#6A6767;
}
/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}
.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}
.el-row {
  flex: 1;
}
.el-tag {
  order: none !important;
}
.collapse {
  display: flex;
  justify-content: space-between;
}
</style>